// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__HodfK","current-page":"Pagination_current-page__LT1md","ellipsis":"Pagination_ellipsis__cHttr"};